import { Injectable } from "@angular/core";
import { ApiService } from "../api.service";
const PATH = "account-user-group-users";
@Injectable({
  providedIn: "root",
})
export class AccountUserGroupsUserHandlerService {
  constructor(private APIService: ApiService) {}

  postAccountUserGroupUser(masterAccountID: number, accountUserGroupUser: any) {
    return this.APIService.post(
      `${PATH}/${masterAccountID}`,
      accountUserGroupUser,
    );
  }

  deleteAccountUserGroupUser(
    masterAccountID: number,
    accountUserGroupUser: any,
  ) {
    return this.APIService.delete(
      `${PATH}/${masterAccountID}/${accountUserGroupUser.id}`,
    );
  }
}
